import { functionalUpdate, OnChangeFn, Row, RowData, Table, TableFeature } from '@tanstack/react-table';
import { TActiveRowId } from '../table.types';

export interface ActiveRowIdTableState {
  activeRowId: TActiveRowId;
}

export interface ActiveRowIdOptions {
  enableActiveRow?: boolean;
  onActiveRowIdChange?: OnChangeFn<TActiveRowId>;
}

export const activeRowIdFeature: TableFeature<any> = {
  getDefaultOptions: (): ActiveRowIdOptions => ({
    enableActiveRow: true,
  }),

  createTable: <TData extends RowData>(table: Table<TData>) => {
    table.setActiveRowId = updater => {
      const oldId = table.getState().activeRowId;
      const newId = functionalUpdate(updater, oldId);
      table.options.onActiveRowIdChange?.(oldId === newId ? undefined : newId);
    };

    table.getActiveRowId = () => {
      const { activeRowId } = table.getState();
      if (activeRowId == null) return undefined;
      return table.getRow(activeRowId);
    };

    table.getIsActiveRowEnabled = () => {
      const { enableActiveRow } = table.options;
      return !!enableActiveRow;
    };
  },

  createRow: <TData extends RowData>(row: Row<RowData>, table: Table<TData>) => {
    row.getIsActive = () => {
      const { enableActiveRow } = table.options;
      if (!enableActiveRow) return false;

      const { activeRowId } = table.getState();
      return row.id === activeRowId;
    };
  },
};
